import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  Tabs,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput, DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBack,
  IconCheck,
  IconSend,
  IconUser,
  IconUserQuestion,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblWarrantyServiceRequestForm } from "../../../model/TblWarrantyServiceRequestForm";
import {
  getBranchSelectMdm,
  getCommuneSelectNew,
  getProvinceSelectNew,
  getTblDmProcessingMethodSelect,
  getTblDmSaleChanelSelect,
} from "../../../service/getSelectApi";
import ItemList from "./ItemList";
import WarrantyItem from "./WarrantyItemList";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import CustMeeting from "./CustMeeting";
import ListCustMeetingInfomation, {
  TblWarrantyReceipt,
} from "./ListCustMeetingInfomation";
import dayjs from "dayjs";

interface MeetingAddress {
  province: number | null;
  commune: number | null;
  custMeeting?: string | null;
  custPhone?: string | null;
  additionalAddress?: string | null;
  content?: string | null;
}

const EditDataView = ({ id, onClose, onSuccess }: EditDataViewProps) => {
  const entity = {
    id: 0,
    custId: 0,
    deliveryId: 0,
    branchId: null,
    inventoryId: null,
    requestStatus: null,
    deliveryDept: null,
    deliveryDate: null,
    custMeeting: null,
    meetingDate: null,
    custPhone: null,
    provinceId: null,
    districtId: null,
    communeId: null,
    streetId: null,
    additionalAddress: null,
    meetingAddress: null,
    processingMethod: null,
    processingMethodName: null,
    employeeIncharge: null,
    requestNum: "",
    note: null,
    vendorId: null,
    message: null,
    address: null,
    priorityId: null,
    warrantyStatus: null,
    locationId: null,
    channel: null,
    channelName: null,
    employeeSupport: null,
    content: null,
    noteAssignRequest: null,
    receiveBranch: null,
    assignDate: null,
    empAssign: null,
    isReceive: false,
    customerGroup: null,
    attribute10: null,
    tblWarrantyServiceRequestFormDetailCommands: [],
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataWarrantyItem, setDataWarrantyItem] = useState<any[]>([]);
  const [dataWarrantyItemSubmit, setDataWarrantyItemSubmit] = useState<any[]>(
    [],
  );
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<
    ComboboxItem[]
  >([]);
  const [dataTblBranch, setDataTblBranch] = useState<ComboboxItem[]>([]);
  const [dataTblSaleChannel, setDataTblSaleChannel] = useState<ComboboxItem[]>(
    [],
  );
  const [dataWarrantyCustomerGroup, setDataWarrantyCustomerGroup] =
    useState<any>([]);
  const [dataMeetingAddress, setDataMeetingAddress] = useState<MeetingAddress>({
    province: null,
    commune: null,
    custMeeting: null,
    custPhone: null,
    content: null,
    additionalAddress: null,
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [handleOnChangeNumber, setHandleOnChangeNumber] = useState<string>("");

  const form = useForm<TblWarrantyServiceRequestForm>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    clearInputErrorOnChange: false,
    initialValues: {
      ...entity,
    },

    transformValues: (values) => ({
      ...values,
      meetingDate: new Date(
        new Date(values.meetingDate ?? "").getTime() + 7 * 60 * 60 * 1000,
      ).toISOString(),
      createDate: new Date(
        new Date(values.createDate ?? "").getTime() + 7 * 60 * 60 * 1000,
      ).toISOString(),
    }),

    validate: {
      custMeeting(value, values, path) {
        if (!value) return "Vui lòng nhập người hẹn gặp!";
      },
      channel(value, values, path) {
        if (!value) return "Vui lòng chọn kênh tiếp nhận!";
      },
      customerGroup(value, values, path) {
        if (!value) return "Vui lòng chọn nhóm khách hàng!";
      },
      provinceId(value, values, path) {
        if (!value) return "Vui lòng chọn tỉnh/thành phố!";
      },
      communeId(value, values, path) {
        if (!value) return "Vui lòng chọn phường/xã!";
      },
      processingMethod(value, values, path) {
        if (!value) return "Vui lòng chọn hình thức xử lý!";
      },
      custPhone: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập số điện thoại khách hàng hẹn gặp!";
        }
        if (!/^\d{8,11}$/.test(value ?? "") && value) {
          return "Số điện thoại phải có từ 8 đến 11 chữ số!";
        }
      },
    },
  });

  const isPhoneInvalid =
    !handleOnChangeNumber ||
    handleOnChangeNumber.length < 9 ||
    handleOnChangeNumber.length > 11;

  const handleOnChange = (value: any, key: string) => {
    if (value !== "Invalid date")
      setDataMeetingAddress((prevData: any) => ({ ...prevData, [key]: value }));
    else {
      setDataMeetingAddress((prevData: any) => ({ ...prevData, [key]: "" }));
    }
  };

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblWarrantyServiceRequestForm/update?id=${id}`,
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        await Promise.all([
          processingMethodSelect(),
          branchSelect(),
          saleChannelSelect(),
          getDataProvinceSelect(),
          getDataWarrantyCustomerGroup(),
        ]);
        form.setValues(dataApi);
        form.resetDirty(dataApi);
        setDataWarrantyItem(dataApi?.tblWarrantyServiceRequestFormDetailModels);
        setDataMeetingAddress({
          province: form.getValues().provinceId ?? null,
          commune: form.getValues().communeId ?? null,
          custMeeting: form.getValues().custMeeting ?? null,
          custPhone: form.getValues().custPhone ?? null,
          content: form.getValues().content ?? null,
          additionalAddress: form.getValues().additionalAddress ?? null,
        });
      }
    }
    close();
  };

  const processingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblProcessingMethod(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const branchSelect = async () => {
    try {
      const getData = await getBranchSelectMdm();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblBranch(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const saleChannelSelect = async () => {
    try {
      const getData = await getTblDmSaleChanelSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblSaleChannel(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const getDataWarrantyCustomerGroup = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblWarrantyCustomerGroup/get-all",
    );

    if (res && res?.success) {
      const getData = res.data;
      setDataWarrantyCustomerGroup(getData);
    }
  };

  const handleSearchByPhone = (type: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách hóa đơn</Title>
        </>
      ),
      children: (
        <Box mt={"18px"}>
          <WarrantyItem
            custId={form.getValues().custId ?? ""}
            selectWarrantyItem={setDataWarrantyItem}
            setFormValues={form.setValues}
            type={type}
          />
        </Box>
      ),
      size: "auto",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalCustMeeting = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin khách hàng </Title>
        </>
      ),
      size: "auto",
      children: (
        <Tabs defaultValue="gallery">
          <Tabs.List>
            <Tabs.Tab value="gallery" leftSection={<IconUser size={14} />}>
              Thông tin khách hàng hẹn gặp
            </Tabs.Tab>
            <Tabs.Tab
              value="messages"
              leftSection={<IconUserQuestion size={14} />}
            >
              Thông tin khách hàng đến bảo hành
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="gallery">
            <CustMeeting
              setDataMeetingAddress={setDataMeetingAddress}
              infoCust={form.setValues}
              view={"CREATE"}
            />
          </Tabs.Panel>
          <Tabs.Panel value="messages">
            <ListCustMeetingInfomation
              setDataMeetingAddress={setDataMeetingAddress}
              infoCust={form.setValues}
              view={"CREATE"}
            />
          </Tabs.Panel>
        </Tabs>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleEditTblWarrantyServiceRequestForm = async (
    dataSubmit: TblWarrantyServiceRequestForm,
  ) => {
    open();

    if (
      dataWarrantyItemSubmit.some(
        (item) => item.serviceType === null || item.itemCode === null,
      )
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập đầy đủ thông tin cho từng sản phẩm !",
      );
      close();
      return;
    }

    if (dataWarrantyItem.length > 0) {
      const dataItemSubmit = dataWarrantyItemSubmit.map((item) => ({
        id: 0,
        requestFormId: 0,
        serial: item.serial?.toString()?.trim() ?? null,
        parentSerial: item.parentSerial ?? null,
        orderId: item.orderId ?? null,
        orderCode: item.orderCode ?? null,
        handleDate: null,
        conclusionError: null,
        resolution: null,
        technicalFeedback: null,
        scheduleTime: null,
        brandId: null,
        empBrand: null,
        phoneBrand: null,
        addressBrand: null,
        noteBrand: null,
        po: null,
        itemId: item.itemId ?? 0,
        empCall: null,
        dateCall: null,
        deadline: null,
        buyingDate: item.buyingDate ?? null,
        warrantyTerm: item.warrantyTerm ?? null,
        serviceType: item.serviceType ?? null,
        entryDate: null,
        attribute1: item.attribute1 ?? null,
        attribute5: item.attribute5 ?? null,
        attribute3: item.attribute3 ?? null,
        attribute4: item.attribute4 ?? null,
        customerOrderId: item.customerOrderId ?? null,
      }));
      dataSubmit = {
        ...dataSubmit,
        custId: !dataSubmit?.custId ? 0 : dataSubmit?.custId,
        tblWarrantyServiceRequestFormDetailCommands: dataItemSubmit,
      };
    } else {
      NotificationExtension.Warn(
        "Vui lòng chọn sản phẩm bảo hành từ hóa đơn mua hàng.",
      );
      close();
      return;
    }
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblWarrantyServiceRequestForm>
    >("/api/v1/TblWarrantyServiceRequestForm/update", dataSubmit);
    if (dataApi?.success) {
      NotificationExtension.Success(
        "Cập nhật phiếu tiếp nhận yêu cầu thành công!",
      );
      setTimeout(() => {
        onSuccess((prev: any) => !prev);
        onClose("");
      }, 1500);
    }
    close();
  };

  const getDataProvinceSelect = async () => {
    const getData = await getProvinceSelectNew();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.id != null && item.name != null)
        ?.map((item: any) => ({
          value: String(item.id),
          label: String(item.name),
        })),
    );
  };

  const getDataCommuneSelect = async () => {
    const currentProvince = dataMeetingAddress.province;
    if (currentProvince) {
      const getData = await getCommuneSelectNew(String(currentProvince));
      const mapped =
        getData
          ?.filter((item: any) => item.value != null && item.text != null)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          })) ?? [];
      setDataCommuneSelect(mapped);

      // Phường/Xã lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
      // -> nếu value không tìm thấy label trong danh sách vừa tải thì reset về null
      setDataMeetingAddress((prev) => {
        const commune = prev.commune;
        const isValid =
          commune === null ||
          commune === undefined ||
          mapped.some((item: any) => String(item.value) === String(commune));
        return isValid ? prev : { ...prev, commune: null };
      });
    }
  };

  const fetchDataListTelephone = async () => {
    const response = await repositoryMdm.get<
      MessageResponse<TblWarrantyReceipt>
    >(
      `/api/v1/TblWarrantyReceipt/create?phoneNumber=${
        form.getValues().custPhone || handleOnChangeNumber
      }`,
    );

    if (response && response.success) {
      const result = response.data ?? {};
      const allValuesNullOrZero = Object.values(result).every(
        (val) => val === null || val === 0,
      );
      if (!allValuesNullOrZero) {
        setDataMeetingAddress((prev: any) => ({
          ...prev,
          custMeeting: result.customerName,
          province: Number(result.provinceId),
          // custPhone: result.phoneNumber ?? "",
          commune: Number(result.communeId),
          additionalAddress: result.address,
        }));

        form.setValues((prev) => ({
          ...prev,
          additionalAddress: result.address ?? "",
          content: result.errorNote ?? "",
          custMeeting: result.customerName,
          // custPhone: result.phoneNumber ?? "",
          province: Number(result.provinceId),
          commune: Number(result.communeId),
          custAddress: result.address,
        }));
      }
    }
  };
  useEffect(() => {
    if (id) {
      callApiGetData();
    } else {
      onClose("");
    }
  }, [id]);

  useEffect(() => {
    if (dataMeetingAddress.province) {
      getDataCommuneSelect();
    }
  }, [dataMeetingAddress.province]);

  // Tỉnh/TP lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
  // -> nếu value không tìm thấy label thì reset Tỉnh/TP và Phường/Xã về null
  useEffect(() => {
    if (
      dataProvinceSelect.length > 0 &&
      dataMeetingAddress.province !== null &&
      dataMeetingAddress.province !== undefined
    ) {
      const isProvinceValid = dataProvinceSelect.some(
        (item) => String(item.value) === String(dataMeetingAddress.province),
      );
      if (!isProvinceValid) {
        setDataMeetingAddress((prev) => ({
          ...prev,
          province: null,
          commune: null,
        }));
      }
    }
  }, [dataProvinceSelect, dataMeetingAddress.province]);

  useEffect(() => {
    if (dataMeetingAddress.province !== null) {
      const toAddress = `${getValueById(
        dataMeetingAddress.commune?.toString() ?? "",
        dataCommuneSelect,
        "label",
      )} - ${getValueById(
        dataMeetingAddress.province?.toString(),
        dataProvinceSelect,
        "label",
      )}`;
      form.setValues((prev) => ({
        ...prev,
        meetingAddress: toAddress
          .replace(/\s*-\s*-\s*/g, " - ")
          .replace(/^\s*-\s*/, ""),
      }));
    }
    form.setValues((prev) => ({
      ...prev,
      isReceive: false,
      communeId: Number(dataMeetingAddress.commune),
      provinceId: Number(dataMeetingAddress.province),
    }));
  }, [dataMeetingAddress, dataProvinceSelect, dataCommuneSelect]);

  useEffect(() => {
    const seenSerials = new Set();
    const uniqueData = dataWarrantyItem.filter((item) => {
      if (seenSerials.has(item.serial)) {
        return false;
      }
      seenSerials.add(item.serial);
      return true;
    });
    setDataWarrantyItem(uniqueData);
  }, [dataWarrantyItem]);

  useEffect(() => {
    if (
      form.getValues()?.attribute8 === "LCN" &&
      form.getValues()?.customerGroup !== null
    ) {
      form.setValues((prev) => ({
        ...prev,
        custMeeting: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "text",
        ),
        custPhone: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute6",
        ),
        additionalAddress: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute5",
        ),
      }));
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "text",
        ),
        "custMeeting",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute6",
        ),
        "custPhone",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute1",
        ),
        "province",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute3",
        ),
        "commune",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute5",
        ),
        "additionalAddress",
      );
    }
  }, [form.getValues()?.customerGroup, form.getValues()?.attribute8]);

  useEffect(() => {
    if (dataMeetingAddress.custPhone) {
      form.setValues((prev) => ({
        ...prev,
        custPhone: dataMeetingAddress.custPhone,
      }));
    }
  }, [dataMeetingAddress.custPhone]);

  useEffect(() => {
    if (dataMeetingAddress.custMeeting) {
      form.setValues((prev) => ({
        ...prev,
        custMeeting: dataMeetingAddress.custMeeting,
      }));
    }
  }, [dataMeetingAddress.custMeeting]);

  useEffect(() => {
    if (dataMeetingAddress.additionalAddress) {
      form.setValues((prev) => ({
        ...prev,
        additionalAddress: dataMeetingAddress.additionalAddress,
      }));
    }
  }, [dataMeetingAddress.additionalAddress]);

  useEffect(() => {
    if (dataMeetingAddress.content) {
      form.setValues((prev) => ({
        ...prev,
        content: dataMeetingAddress.content,
      }));
    }
  }, [dataMeetingAddress.content]);

  useEffect(() => {
    if (dataMeetingAddress.custPhone) {
      form.setValues((prev) => ({
        ...prev,
        custPhone: dataMeetingAddress.custPhone,
      }));
    }
  }, [dataMeetingAddress.custPhone]);
  return (
    <>
      <Box
        component="form"
        mx="auto"
        mt={-7.5}
        p={"0px 10px"}
        onSubmit={form.onSubmit((e: TblWarrantyServiceRequestForm) => {
          handleEditTblWarrantyServiceRequestForm(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Flex justify={"space-between"} align={"center"}>
          <Badge
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            Chỉnh sửa phiếu tiếp nhận yêu cầu
          </Badge>
          <Group
            justify="space-between"
            align="center"
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
            }}
          >
            <Flex w={"100%"} justify={"flex-end"} gap={"md"}>
              <Button
                type="button"
                color="red"
                loading={visible}
                onClick={() => {
                  onClose("");
                }}
                leftSection={!visible ? <IconArrowBack size={18} /> : undefined}
              >
                Thoát
              </Button>
              <Button
                type="submit"
                color="teal"
                loading={visible}
                leftSection={!visible ? <IconCheck size={18} /> : undefined}
              >
                Lưu
              </Button>
            </Flex>
          </Group>
        </Flex>
        <Grid>
          <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
            <Fieldset legend="Thông tin yêu cầu xử lý">
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Chi nhánh xử lý yêu cầu"
                    placeholder="Chọn chi nhánh xử lý yêu cầu"
                    data={dataTblBranch}
                    value={
                      form.getValues().branchId
                        ? form.getValues().branchId?.toString()
                        : null
                    }
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <DateTimePicker
                    label="Ngày tiếp nhận"
                    locale="vi"
                    valueFormat="DD-MM-YYYY hh:mm A"
                    minDate={(() => {
                      const date = new Date();
                      date.setMonth(date.getMonth() - 1);
                      date.setDate(1);
                      return date;
                    })()}
                    value={
                      form.getValues()?.createDate
                        ? new Date(form.getValues()?.createDate ?? "")
                        : null
                    }
                    onChange={(e) =>
                      form.setValues((prev) => ({
                        ...prev,
                        createDate: e ? new Date(e ?? "")?.toISOString() : null,
                      }))
                    }
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Người tiếp nhận yêu cầu"
                    variant="filled"
                    readOnly
                    {...form.getInputProps("createByName")}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Mã phiếu tiếp nhận yêu cầu"
                    readOnly
                    variant="filled"
                    {...form.getInputProps("requestNum")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Kênh tiếp nhận"
                    placeholder="Chọn kênh tiếp nhận"
                    clearable
                    searchable
                    data={dataTblSaleChannel}
                    value={form.getValues().channel?.toString() ?? null}
                    {...form.getInputProps("channel")}
                    onChange={(value) => {
                      form.setValues((prev) => ({
                        ...prev,
                        channel: value,
                      }));
                    }}
                    comboboxProps={{ width: 200 }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Hình thức xử lý"
                    clearable
                    searchable
                    placeholder="Chọn hình thức xử lý"
                    data={dataTblProcessingMethod}
                    value={form.getValues().processingMethod?.toString() ?? ""}
                    {...form.getInputProps("processingMethod")}
                    onChange={(e) => {
                      form.setValues((prev) => ({
                        ...prev,
                        processingMethod: e ? e?.toString() : null,
                      }));
                    }}
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <TextInput
                    label="Số phiếu tiếp nhận yêu cầu"
                    placeholder="Số phiếu tiếp nhận yêu cầu"
                    type="number"
                    {...form.getInputProps("attribute10")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Select
                    label="Nhóm khách hàng"
                    placeholder="Nhập nhóm khách hàng"
                    data={dataWarrantyCustomerGroup
                      ?.filter(
                        (item: any) =>
                          item.text !== null && item.value !== null,
                      )
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value?.toString(),
                      }))}
                    value={form.getValues().customerGroup?.toString() ?? null}
                    {...form.getInputProps("customerGroup")}
                    onChange={(value) =>
                      form.setValues((prev) => ({
                        ...prev,
                        customerGroup: value ? value : null,
                        attribute8: getValueById(
                          value?.toString() ?? "",
                          dataWarrantyCustomerGroup,
                          "attribute7",
                        ),
                      }))
                    }
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
            <Fieldset legend="Thông tin khách hàng hẹn gặp">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Người hẹn gặp"
                    placeholder={"Nhập người hẹn gặp"}
                    onDoubleClick={() => {
                      // Nhóm khách hàng LCN thì không cho chọn lại Người hẹn gặp
                      if (form.getValues().attribute8 === "LCN") return;
                      modalCustMeeting();
                    }}
                    {...form.getInputProps("custMeeting")}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        custMeeting: value,
                      }));
                      form.setFieldValue("custMeeting", value);
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Số điện thoại"
                    value={dataMeetingAddress.custPhone || ""}
                    placeholder={"Nhập số điện thoại"}
                    {...form.getInputProps("custPhone")}
                    onKeyPress={(e) => {
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Delete" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    rightSection={
                      <ActionIcon
                        disabled={
                          isPhoneInvalid || !dataMeetingAddress.custPhone
                        }
                        bd="1px solid blue"
                        onClick={fetchDataListTelephone}
                        color="blue"
                        variant="light"
                        aria-label="Settings"
                      >
                        <IconSend
                          style={{ width: "70%", height: "70%" }}
                          stroke={1.5}
                        />
                      </ActionIcon>
                    }
                    withAsterisk
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setHandleOnChangeNumber(value);
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        custPhone: value,
                      }));
                      form.setFieldValue("custPhone", value);
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <DatePickerInput
                    label="Ngày hẹn gặp"
                    placeholder="Nhập ngày hẹn gặp"
                    locale="vi"
                    valueFormat="DD-MM-YYYY"
                    value={
                      form.getValues().meetingDate
                        ? new Date(form.getValues().meetingDate ?? "")
                        : null
                    }
                    onChange={(e) =>
                      form.setValues((prev) => ({
                        ...prev,
                        meetingDate: e
                          ? new Date(e ?? "").toDateString()
                          : null,
                      }))
                    }
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    label="Tỉnh/TP"
                    placeholder="Nhập tỉnh/thành phố"
                    data={dataProvinceSelect}
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    value={
                      form.getValues().provinceId || dataMeetingAddress.province
                        ? form.getValues().provinceId?.toString() ||
                          dataMeetingAddress?.province?.toString()
                        : null
                    }
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    withAsterisk
                    {...form.getInputProps("provinceId")}
                    onChange={(e) => {
                      handleOnChange(e, "province");
                      handleOnChange(null, "commune");
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    key={dataMeetingAddress.commune}
                    label="Phường/Xã"
                    placeholder="Nhập phường/xã"
                    data={dataCommuneSelect}
                    searchable
                    clearable
                    disabled={
                      !dataMeetingAddress.province ||
                      String(dataMeetingAddress.province).length === 0
                    }
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    withAsterisk
                    {...form.getInputProps("communeId")}
                    value={
                      form.getValues().communeId ||
                      dataMeetingAddress.commune?.toString()
                        ? form.getValues().communeId?.toString() ||
                          dataMeetingAddress.commune?.toString()
                        : null
                    }
                    onChange={(e) => {
                      handleOnChange(e, "commune");
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Địa chỉ cụ thể (Không bao gồm Tỉnh/TP, Phường/Xã)"
                    value={dataMeetingAddress.additionalAddress || ""}
                    placeholder="Nhập địa chỉ cụ thể"
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    {...form.getInputProps("additionalAddress")}
                    onChange={(e) =>
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        additionalAddress: e.target.value,
                      }))
                    }
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Nội dung"
                    placeholder={"Nhập nội dung"}
                    value={dataMeetingAddress.content || ""}
                    {...form.getInputProps("content")}
                    onChange={(e) =>
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        content: e.target.value,
                      }))
                    }
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>

          <Grid.Col span={{ xs: 12, sm: 12, md: 12, lg: 12 }} px={0}>
            <ItemList
              handleSearchByPhone={handleSearchByPhone}
              onSelect={setDataWarrantyItemSubmit}
              setDataWarrantyItem={setDataWarrantyItem}
              dataItem={dataWarrantyItem}
              onDelete={setDataWarrantyItem}
              setFormValues={form.setValues}
              typeProduct={form.getValues()?.attribute6}
              actionView={"EDIT"}
            />
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
  onSuccess: any;
};
